// This file is AUTOGENERATED, do not edit it manually!!!

export const filters = {
    Activity_Text: 'Activity',
    ActivityActualBilling: 'Activity billable',
    ActivityActualCompletionDateCondition_Text: 'Activity actual completion date',
    ActivityActualCost: 'Activity actual cost',
    ActivityActualGreaterThanEstimated_Text: 'Underestimated activities',
    ActivityActualHours: 'Activity actual hours',
    ActivityActualLaborBilling: 'Activity actual billable labor ',
    ActivityActualLaborCost: 'Activity actual labor cost',
    ActivityBillableHours: 'Activity billable hours',
    ActivityBilled: 'Activity invoiced',
    ActivityBilledLabor: 'Activity invoiced labor',
    ActivityBilledPercentage: 'Activity invoiced, %',
    ActivityBudgetVariance: 'Activity budget variance',
    ActivityCreationDateCondition_Text: 'Activity creation date',
    ActivityCreator_Text: 'Activity creators',
    ActivityCreatorCondition_Empty_Text: 'System',
    ActivityCreatorCondition_Text: 'Activity creator',
    ActivityCustomFieldCondition_Text: 'Activity custom fields',
    ActivityDuration: 'Activity duration',
    ActivityEACBillableExpenses: 'Activity EAC billable expenses',
    ActivityEACBilling: 'Activity EAC billable',
    ActivityEACCost: 'Activity EAC cost',
    ActivityEACExpenses: 'Activity EAC expenses',
    ActivityEACLaborBilling: 'Activity EAC billable labor',
    ActivityEACLaborCost: 'Activity EAC labor cost',
    ActivityEACNonBillableExpenses: 'Activity EAC non-billable expenses',
    ActivityEndDateCondition_Text: 'Activity end date',
    ActivityEstimatedExpensesAmount: 'Activity ETC expenses',
    ActivityEstimatedExpensesBillableAmount: 'Activity ETC billable expenses',
    ActivityEstimatedExpensesNonBillableAmount: 'Activity ETC non-billable expenses',
    ActivityEstimatedHours: 'Activity estimated hours',
    ActivityETCBilling: 'Activity ETC billable',
    ActivityETCCost: 'Activity ETC cost',
    ActivityETCLaborBilling: 'Activity ETC billable labor',
    ActivityETCLaborCost: 'Activity ETC labor cost',
    ActivityExpectedProfit: 'Activity expected profit',
    ActivityExpectedProfitPercentage: 'Activity expected profit, %',
    ActivityExpensesAmount: 'Activity actual expenses',
    ActivityExpensesBillableAmount: 'Activity actual billable expenses',
    ActivityExpensesBilledAmount: 'Activity invoiced expenses',
    ActivityExpensesNonBillableAmount: 'Activity actual non-billable expenses',
    ActivityHealthCondition_Text: 'Activity health',
    ActivityHealthTypes: 'Activity health',
    ActivityIsMilestone: 'Activity is milestone',
    ActivityNonBillableHours: 'Activity non-billable hours',
    ActivityProcessCondition_Text: 'Activity progress',
    ActivityProfit: 'Activity profit',
    ActivityProfitPercentage: 'Activity profit, %',
    ActivityProgress_Text: 'Activity progress',
    ActivityStartDateCondition_Text: 'Activity start date',
    ActivityStatusCondition_Text: 'Activity status',
    ActivityTotalBudget: 'Activity total budget',
    ActivityTypeCondition_Text: 'Activity type:',
    ActivityTypes_Issue: 'Issue',
    ActivityTypes_Request: 'Request',
    ActivityTypes_Task: 'Task',
    ActivityTypesCondition_Text: 'Activity types',
    ActualCompletionDate_Text: 'Actual completion date',
    add_filters: 'Add filters',
    AdvancedFilterTooltipContent_Text: 'Click here to view all possible filtering options',
    AdvancedFilterTooltipTitle_Text: 'Advanced filters',
    AllActivities_Text: 'Activity',
    Apply_Text: 'Apply',
    AssigneeCondition_Text: 'Activity assignees',
    AssigneeOption_Text: 'Activity assignees',
    AssigneeTeamCondition_Entity: 'teams',
    AssigneeUserCondition_Empty_Text: 'No assignees',
    AssigneeUserCondition_Entity: 'activity assignees',
    BoolCustomField_No_Text: 'No',
    BoolCustomField_NotSelected_Text: 'Not selected',
    BoolCustomField_Yes_Text: 'Yes',
    BudgetAndCosts_Filters_Group: 'Budget and costs',
    CategoriesCondition_Text: 'Categories',
    CategoryCondition_Empty_Text: 'No category',
    CategoryCondition_Entity: 'categories',
    CategoryCondition_Text: 'Category',
    Clear_All_Text: 'Clear all filters',
    CompletedStatus_Text: 'Completed',
    constraints_filters_group: 'Constraints',
    ContainMore_Text: 'There are more results, keep typing...',
    CreationDate_Text: 'Creation date',
    CustomerCondition_Empty_Text: 'No customer',
    CustomerCondition_Entity: 'customers',
    CustomerCondition_Text: 'Customers',
    CustomFieldsFilters_Group: 'Custom fields',
    DraftCondition_Text: 'Drafts',
    DraftStatus_Text: 'Drafts',
    EndDate_Text: 'End date',
    FilterByKeyword_Text: 'Filter by keyword',
    FilterByPeriod_Text: 'Filter by period',
    FilterByTimeframe_Text: 'Filter by timeframe',
    FilterTabs_Tab1: 'Statuses',
    FilterTabs_Tab2: 'Resources & constraints',
    FilterTabs_Tab3: 'Health & Progress',
    FilterTabs_Tab4: 'Projects, customers & more',
    FilterTabs_Tab5: 'Custom fields',
    Followed: 'Following',
    FollowedByMe_Text: 'Activities followed by me',
    From_Text: 'from',
    general: 'General',
    HealthCondition_Text: 'Health',
    HealthItemType_Bad: 'Trouble',
    HealthItemType_Good: 'Good',
    HealthItemType_Medium: 'At risk',
    HealthItemType_NotCalculated: 'Not calculated',
    HealthTooltip_Text: 'Health is a calculated index that shows how well a project or activity is going on',
    HealthTooltipLink_Text: 'View more in our online help',
    HoursCondition_Text: 'Time',
    HoursFilters_Group: 'Time',
    HoursLeft: 'Hours left',
    InProgressStatus_Text: 'In progress',
    InThePast: 'In the past',
    InvalidDate: 'Date must be in \'{0}\' format.',
    Issue_Text: 'Issue',
    KeepTyping_Text: 'Keep typing...',
    ListCustomFieldCondition_Empty_Text: 'Not selected',
    ManualRange: 'Specified date range...',
    Me: 'Me',
    Menu_Dates: 'Dates',
    Milestone_Text: 'Milestone',
    MoneyCondition_Text: 'Money',
    More_Text: 'More',
    MultiSelectCustomFieldCondition_Empty_Text: 'Not selected',
    NextMonth: 'Next month',
    NextWeek: 'Next week',
    no_filters: 'No filters to display',
    NoCategory: 'No category',
    NoMatch_Text: 'Sorry, nothing was found',
    OnHoldStatus_Text: 'On hold',
    PeopleCondition_Text: 'People',
    PinTooltip_Text: 'Pin',
    Portfolio_Status_Text: 'Portfolio status',
    PortfolioCondition_Empty_Text: 'No portfolio',
    PortfolioCondition_Entity: 'portolios',
    PortfolioCondition_Text: 'Portfolios',
    PortfolioCreator_Text: 'Portfolio creators',
    PortfolioCreatorCondition_Text: 'Portfolio creator',
    PortfolioManager_Text: 'Portfolio managers',
    PortfolioManagerCondition_Text: 'Portfolio manager',
    PreviousMonth: 'Previous month',
    PreviousWeek: 'Previous week',
    PreviousYear: 'Previous year',
    PriorityCondition_Text: 'Priorities',
    Progress_Filters_Group: 'Progress',
    ProgressCondition_Entity: 'Progress: ',
    ProgressCondition_Text: 'Progress',
    Project_Text: 'Project',
    ProjectActualBilling: 'Project billable',
    ProjectActualCompletionDateCondition_Text: 'Project actual completion date',
    ProjectActualCost: 'Project actual cost',
    ProjectActualGreaterThanEstimated_Text: 'Underestimated projects',
    ProjectActualHours: 'Project actual hours',
    ProjectActualLaborBilling: 'Project actual billable labor',
    ProjectActualLaborCost: 'Project actual labor cost',
    ProjectBillableHours: 'Project billable hours',
    ProjectBilled: 'Project invoiced',
    ProjectBilledLabor: 'Project invoiced labor',
    ProjectBilledPercentage: 'Project invoiced, %',
    ProjectBudgetVariance: 'Project budget variance',
    ProjectCondition_EmptyText: 'No project selected',
    ProjectCondition_Entity: 'projects',
    ProjectCondition_Text: 'Projects',
    ProjectCostExceedBudget_Text: 'Overbudgeted projects',
    ProjectCreationDateCondition_Text: 'Project creation date',
    ProjectCreator_Text: 'Project creators',
    ProjectCreatorCondition_Text: 'Project creator',
    ProjectCustomFieldCondition_Text: 'Project custom fields',
    ProjectDuration: 'Project duration',
    ProjectEACBillableExpenses: 'Project EAC billable expenses',
    ProjectEACBilling: 'Project EAC billable',
    ProjectEACCost: 'Project EAC cost',
    ProjectEACExpenses: 'Project EAC expenses',
    ProjectEACLaborBilling: 'Project EAC billable labor',
    ProjectEACLaborCost: 'Project EAC labor cost',
    ProjectEACNonBillableExpenses: 'Project EAC non-billable expenses',
    ProjectEndDateCondition_Text: 'Project end date',
    ProjectEstimatedExpensesAmount: 'Project ETC expenses',
    ProjectEstimatedExpensesBillableAmount: 'Project ETC billable expenses',
    ProjectEstimatedExpensesNonBillableAmount: 'Project ETC non-billable expenses',
    ProjectEstimatedHours: 'Project estimated hours',
    ProjectETCBilling: 'Project ETC billable',
    ProjectETCCost: 'Project ETC cost',
    ProjectETCLaborBilling: 'Project ETC billable labor',
    ProjectETCLaborCost: 'Project ETC labor cost',
    ProjectExpectedProfit: 'Project expected profit',
    ProjectExpectedProfitPercentage: 'Project expected profit, %',
    ProjectExpensesAmount: 'Project actual expenses',
    ProjectExpensesBillableAmount: 'Project actual billable expenses',
    ProjectExpensesBilledAmount: 'Project invoiced expenses',
    ProjectExpensesNonBillableAmount: 'Project actual non-billable expenses',
    ProjectHealthCondition_Text: 'Project health',
    ProjectHealthTypes: 'Project health',
    ProjectManager_Text: 'Project managers',
    ProjectManagerCondition_Text: 'Project manager',
    ProjectMemberCondition_Text: 'Project member',
    ProjectNonBillableHours: 'Project non-billable hours',
    ProjectPriorityCondition_Text: 'Project priority',
    ProjectPriorityCondition_Text_Template: 'Projects with %s priority',
    ProjectProcessCondition_Text: 'Project progress',
    ProjectProfit: 'Project profit',
    ProjectProfit_Text: 'Projects at financial loss',
    ProjectProfitPercentage: 'Project profit, %',
    ProjectProgress_Text: 'Project progress',
    ProjectsAndTasksList_Title: 'Projects and tasks',
    ProjectsCustomersAndMore_Filters_Group: 'Projects, customers & more',
    ProjectStartDateCondition_Text: 'Project start date',
    ProjectStatusCondition_Text: 'Project status',
    ProjectTotalBudget: 'Project total budget',
    QuickFilterWatermark: 'Filter by...',
    range_condition_text: 'Range',
    Request_Text: 'Request',
    resource_types_condition_text: 'Resources',
    resource_types_planning_condition_text: 'Projects with resources',
    resource_types_unnamed_label: 'Unnamed resources',
    resource_types_user_label: 'Users',
    ResourceRequestApprover_Text: 'Resource request approver',
    ResourceRequestCreator_Text: 'Resource request creator',
    ResourceRequestStatuses_Approved: 'Approved',
    ResourceRequestStatuses_Rejected: 'Rejected',
    ResourceRequestStatuses_WaitingForApproval: 'Waiting for approval',
    ResourceRequestStatuses_WithoutRequest: 'Without request',
    ResourceRequestStatusFilter_Text: 'Resource request status',
    resources_filters_group: 'Resources',
    resources_requests_filters_group: 'Resource requests',
    ResourcesAndConstraints_Filters_Group: 'Resources & constraints',
    roles_condition_text: 'Roles',
    RollBack_Text: 'Back to previous filters',
    SaveFilters_Title: 'Saved filters',
    set_filters: 'Set filters using the',
    set_filters_part2: 'icon',
    skills_condition_text: 'Skills',
    StartDate_Text: 'Start date',
    Statuses_Filters_Group: 'Status',
    StatusesCountFormat: '1#{0} status#{0} statuses',
    Task_Text: 'Task',
    TaskCondition_Entity: 'activities',
    TaskCondition_Text: 'Activity',
    TaskCostExceedBudget_Text: 'Overbudgeted activities',
    TaskPriorityCondition_Entity: 'activity priorities',
    TaskPriorityCondition_Text: 'Activity priority',
    TaskPriorityCondition_Text_Template: 'Activities with %s priority',
    TasksAssignedToMilestone_Text: 'Activity assigned to milestone',
    teams_condition_text: 'Teams',
    TemplateCondition_Text: 'Templates',
    TemplateStatus_Text: 'Templates',
    ThisMonth: 'This month',
    ThisWeek: 'This week',
    ThisYear: 'This year',
    To_Text: 'to',
    Today: 'Today',
    TypesCondition_Text: 'Types',
    UnpinTooltip_Text: 'Unpin',
    users_condition_text: 'Users',
    Yesterday: 'Yesterday',
};
